<template>
  <div class="gb-zm-wrapper"
       v-if="availableTrees !== null && availableTrees.length > 0">
    <CTA :label="ctaLabel" v-if="$settings.options === null" />
    <main-button  v-if="$settings.options === null" />
    <div class="gb-zm-widget" v-show="isVisible">
      <ul class="gb-zm-channels" >
        <li v-for="(tree, index) in availableTrees"
            v-bind:key="index"
            :class="getClass(tree)"
            class="gb-zm-channel"
            v-on:click.prevent="handleClick(tree, $event)">
          <div v-if="getClass(tree) === 'iadvize' ">
            <span v-html="tree.target" :ref="getRef(tree)"></span>
          </div>
          <div v-else>
            <squircle :clss="'gb-zm-squircle'" />
            <span class="gb-zm-channel-btn" v-html="tree.target"
                  :ref="getRef(tree)" :title="tree.title">
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CTA from './CTA'
import MainButton from './MainButton'
import Squircle from '@/components/Squircle'
import Widget from '@/components/Widget'

export default {
  name: 'Widget',
  extends: Widget,
  components: {
    CTA,
    MainButton,
    Squircle
  },
  data () {
    return {
      cta: 'Besoin d\'aide ?',
      disabled: false,
      isABCSupported: false
    }
  },
  computed: {
    availableTrees () {
      return this.$store.getters.availableTrees
    },
    ctaLabel () {
      return this.$store.getters.cta
    },
    isEnable () {
      return this.isMobileDevice && !this.disabled
    },
    isMobileDevice () {
      return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    isVisible () {
      return this.$store.getters.state === 'shown'
    },
    title () {
      return this.$store.getters.title
    }
  },
  methods: {
    _handleWebChat (tree, ref) {
      this.$botSettings.keyword = ref
      const step = window.GbBot.$store.getters.step === 'button' ? 'chatbox' : 'button'
      window.GbBot.$store.commit('setHasZenMsgButton', true)
      window.GbBot.$store.dispatch({
        type: 'changeStep',
        step: step
      })
      window.GbBot.$store.dispatch({
        type: 'initWebsocket'
      })

      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'webchat'
      }
      this.$store.commit('setState', 'back')
      this.$http.post(this.$settings.url + 'log', data)
    },
    disable () {
      this.toggle(false)
      this.disabled = true
    },
    enable () {
      this.disabled = false
    },
    getClass (tree) {
      let clss = ''
      if (tree.target.indexOf('apple-business-chat') > -1) {
        clss = 'abc'
      } else if (tree.target.indexOf('m.me') > -1) {
        clss = 'messenger'
      } else if (tree.target.indexOf('whatsapp') > -1) {
        clss = 'whatsapp'
      } else {
        clss = 'webchat'
      }
      return clss
    },
    getRef (tree) {
      if (tree.target.indexOf('apple-business-chat') > -1) {
        return 'ABC'
      }
      return ''
    },
    getReferrer (tree) {
      const newNode = document.createElement('div')
      newNode.setAttribute('class', 'wrapper')
      newNode.innerHTML = tree.target
      const button = newNode.querySelector('button')
      const referrer = button.getAttribute('data-gb-keyword')
      return referrer
    },
    init () {
      this.$store.dispatch('initAvailableTrees', {
        isABCSupported: this.isABCSupported,
        $settings: this.$settings
      })
    },
    toggle (forceVisibility) {
      if (forceVisibility === undefined || forceVisibility !== false) {
        const data = {
          kind: 'show_channels_list'
        }
        this.$http.post(this.$settings.url + 'log', data).then(response => {
        })
      }
      this.hidden = forceVisibility !== undefined ? !forceVisibility : !this.hidden
    },
    triggerABC () {
      window.location.href = this.$refs.ABC.querySelector('a').href
    }
  },
  created () {
    this.hidden = true
  },
  mounted () {
    if (this.$store.getters.isOpen === true) {
      this.init()
    }
  }
}

</script>

<style lang="scss" >
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

  $primary: rgb(110, 127, 11);
  $chat: 'process.env.VUE_APP_FLOA_COLOR';

  .gb-zm-wrapper {
    font-family: Roboto, "Helvetica Neue", Arial, sans-serif;

    h5 {
      text-align: center;
      font-size: 20px;
      margin-bottom: 40px;
    }

    .gb-zm-widget {
      color: $primary;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, .9);
      position: static;
    }

    /*** CHANNELS ***/

    .gb-zm-channels {
      bottom: 60px;
      list-style: none;
      margin: 0;
      padding: 0;
      position: fixed;
      right: 20px;
      width: 60px;

      @media (max-width: 640px) {
        width: 40px !important;
      }

      & > li {
        // position: relative;
        margin-bottom: 27px;
      }

      .gb-zm-channel {
        display: block;
        height: 60px;
        filter: drop-shadow(0 2.5px 5px rgba(100, 100, 100, 1));
        font-size: 14px;
        color: $primary;
        width: 60px;

        @media (max-width: 640px) {
          height: 40px !important;
          left: 0px;
          width: 40px;
        }

        .gb-zm-channel-btn {
          background-color: rgb(255, 255, 255);
          background-size: 56.64%;
          background-position: center;
          background-repeat: no-repeat;
          border: none;
          cursor: pointer;
          display: block;
          position: relative;
          top: -170px;
          z-index: 0;
          pointer-events: auto;

          height: 60px !important;
          width: 60px;
          border-radius: 33.34%;
          clip-path: url(#squircle);

          @media (max-width: 640px) {
            width: 40px;
            height: 40px !important;
          }

          &:focus {
            outline: none;
          }
        }

        &.messenger {
          background: none;

          .gb-zm-channel-btn {
            background-image: url("../../assets/yves-rocher-be/messenger.svg");
            background-size: 35px auto;
            padding-right: 40px;

            @media (max-width: 640px) {
              background-size: 25px auto;
            }
          }
        }

        &.whatsapp {
          background: none;

          .gb-zm-channel-btn {
            background-color: rgb(35,209, 1);
            background-image: url("../../assets/yves-rocher-be/whatsapp.svg");
            background-size: 35px auto;
            padding-right: 40px;

            @media (max-width: 640px) {
              background-size: 25px auto;
            }
          }
        }

        &.webchat {
          display: none;
          background: none;

          .gb-zm-channel-btn {
            background-color: rgb(133, 147, 36);
            background-image: url("../../assets/yves-rocher-be/web.png") !important;
            background-size: 35px auto;
            padding-right: 40px;

            @media (max-width: 640px) {
              background-size: 25px auto;
            }

            button {
              background: transparent;
              border: none;
              height: 60px;
              width: 60px;

              @media (max-width: 640px) {
                height: 40px;
                width: 40px;
              }
            }
          }
        }

        small {
          font-size:11.2px;
        }
      }
    }

    .apple-business-chat-message-container {
      align-items: center;
      background-image: linear-gradient(8deg, #61cd43 0%, #a3f781 100%);
      border-radius: 0% !important;
      display: flex;
      height: 60px;
      justify-content: center;
      padding-top: 0px !important;
      padding-left: 0px !important;
      width: 60px;

      @media (max-width: 640px) {
        height: 40px !important;
        width: 40px;
      }

      svg {
        height: 60px;
        width: 60px;

        @media (max-width: 640px) {
          height: 40px !important;
          width: 40px;
        }
      }
    }

    .gb-zm-chat > *:first-child {
      background-color: $chat;
      position: relative;
      flex-shrink: 0;

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        margin-left: 1px;
      }
    }
  }
</style>
